export function zoomInit() {
    const pictureArea = $('#picture-area');
    const pictureWrap = $('#picture-wrap');
    const img = $('.picture-source');

    if (img.length > 0) {
        const ZOOM_SPEED = 0.1;
        const MIN_ZOOM = 0.3;
        const MAX_ZOOM = 5.0;

        let currentScale, currentX, currentY;
        let originalImageWidth, originalImageHeight;
        let containerWidth, containerHeight;

        function calculateFitToScreen() {
            containerWidth = pictureArea.width();
            containerHeight = pictureArea.height();

            originalImageWidth = parseInt(img.attr('width'));
            originalImageHeight = parseInt(img.attr('height'));

            const imageOffsetLeft = parseInt(img.css('left')) || 0;
            const imageOffsetTop = parseInt(img.css('top')) || 0;

            const wrapWidth = parseInt(pictureWrap.css('width')) || originalImageWidth;
            const wrapHeight = parseInt(pictureWrap.css('height')) || originalImageHeight;

            const contentLeft = Math.min(0, imageOffsetLeft);
            const contentTop = Math.min(0, imageOffsetTop);
            const contentRight = Math.max(wrapWidth, imageOffsetLeft + originalImageWidth);
            const contentBottom = Math.max(wrapHeight, imageOffsetTop + originalImageHeight);
            const totalContentWidth = contentRight - contentLeft;
            const totalContentHeight = contentBottom - contentTop;

            const scaleX = containerWidth / totalContentWidth;
            const scaleY = containerHeight / totalContentHeight;
            const maxScale = Math.min(scaleX, scaleY);

            let fitScale;
            if (maxScale > 1) {
                fitScale = maxScale * 0.9;
            } else {
                fitScale = maxScale * 0.9;
            }

            const scaledContentWidth = totalContentWidth * fitScale;
            const scaledContentHeight = totalContentHeight * fitScale;
            const centerX = (containerWidth - scaledContentWidth) / 2;
            const centerY = (containerHeight - scaledContentHeight) / 2;

            const adjustedX = centerX - (contentLeft * fitScale);
            const adjustedY = centerY - (contentTop * fitScale);
            return {
                scale: fitScale,
                x: adjustedX,
                y: adjustedY
            };
        }

        function initializeImage() {
            const fit = calculateFitToScreen();
            currentScale = fit.scale;
            currentX = fit.x;
            currentY = fit.y;
            applyTransform();
        }

        function applyTransform() {
            pictureWrap.css({
                'transform': `scale(${currentScale})`,
                'transform-origin': '0 0',
                'left': `${currentX}px`,
                'top': `${currentY}px`
            });
            updateZoomDisplay();
        }

        function updateZoomDisplay() {
            const zoomPercentage = Math.round(currentScale * 100);
            $('#zoom-display').text(`${zoomPercentage}%`);

            const zoomDisplay = $('#zoom-display');
            zoomDisplay.removeClass('fade-out');

            clearTimeout(window.zoomDisplayTimeout);
            window.zoomDisplayTimeout = setTimeout(() => {
                zoomDisplay.addClass('fade-out');
            }, 3000);
        }

        pictureArea.on('wheel', function (e) {
            e.preventDefault();
            const event = e.originalEvent;

            const delta = event.deltaY > 0 ? -1 : 1;
            const zoomFactor = 1 + (ZOOM_SPEED * delta);
            const newScale = currentScale * zoomFactor;

            if (newScale < MIN_ZOOM || newScale > MAX_ZOOM) {
                return;
            }

            const rect = pictureArea[0].getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const mouseY = event.clientY - rect.top;

            const imageMouseX = (mouseX - currentX) / currentScale;
            const imageMouseY = (mouseY - currentY) / currentScale;

            currentScale = newScale;

            currentX = mouseX - (imageMouseX * currentScale);
            currentY = mouseY - (imageMouseY * currentScale);

            applyTransform();
        });

        let isDragging = false;
        let dragStartX, dragStartY;
        let startPosX, startPosY;

        let initialPinchDistance = 0;
        let initialScale = 1;
        let initialTouchX = 0;
        let initialTouchY = 0;
        let touchStartX = 0;
        let touchStartY = 0;
        let isTouching = false;
        pictureArea.on('mousedown', function (e) {
            if (e.target.classList.contains('picture-label')) {
                return;
            }

            if (isTouching) return;
            isDragging = true;
            dragStartX = e.clientX;
            dragStartY = e.clientY;
            startPosX = currentX;
            startPosY = currentY;
            pictureArea.css('cursor', 'grabbing');
            e.preventDefault();
        });
        $(document).on('mousemove', function (e) {
            if (!isDragging) return;
            const deltaX = e.clientX - dragStartX;
            const deltaY = e.clientY - dragStartY;
            currentX = startPosX + deltaX;
            currentY = startPosY + deltaY;
            applyTransform();
        });
        $(document).on('mouseup', function () {
            if (isDragging) {
                isDragging = false;
                pictureArea.css('cursor', 'move');
            }
        });

        pictureArea.on('contextmenu', function (e) {
            e.preventDefault();
        });

        function getTouchDistance(touch1, touch2) {
            const dx = touch1.clientX - touch2.clientX;
            const dy = touch1.clientY - touch2.clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }

        function getTouchCenter(touch1, touch2) {
            return {
                x: (touch1.clientX + touch2.clientX) / 2,
                y: (touch1.clientY + touch2.clientY) / 2
            };
        }

        pictureArea.on('touchstart', function (e) {
            e.preventDefault();
            const touches = e.originalEvent.touches;
            if (touches.length === 1) {
                isTouching = true;
                isDragging = false;
                touchStartX = touches[0].clientX;
                touchStartY = touches[0].clientY;
                startPosX = currentX;
                startPosY = currentY;
            } else if (touches.length === 2) {
                isTouching = false;
                isDragging = false;
                initialPinchDistance = getTouchDistance(touches[0], touches[1]);
                initialScale = currentScale;
                const center = getTouchCenter(touches[0], touches[1]);
                const rect = pictureArea[0].getBoundingClientRect();
                initialTouchX = center.x - rect.left;
                initialTouchY = center.y - rect.top;
            }
        });
        pictureArea.on('touchmove', function (e) {
            e.preventDefault();
            const touches = e.originalEvent.touches;
            if (touches.length === 1 && isTouching) {
                const deltaX = touches[0].clientX - touchStartX;
                const deltaY = touches[0].clientY - touchStartY;
                currentX = startPosX + deltaX;
                currentY = startPosY + deltaY;
                applyTransform();
            } else if (touches.length === 2) {
                const currentDistance = getTouchDistance(touches[0], touches[1]);
                const scale = (currentDistance / initialPinchDistance) * initialScale;

                const newScale = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, scale));
                if (newScale === currentScale) return;

                const imageMouseX = (initialTouchX - currentX) / currentScale;
                const imageMouseY = (initialTouchY - currentY) / currentScale;
                currentScale = newScale;
                currentX = initialTouchX - (imageMouseX * currentScale);
                currentY = initialTouchY - (imageMouseY * currentScale);
                applyTransform();
            }
        });
        pictureArea.on('touchend touchcancel', function (e) {
            const touches = e.originalEvent.touches;
            if (touches.length === 0) {
                isTouching = false;
                isDragging = false;
            } else if (touches.length === 1) {
                isTouching = true;
                touchStartX = touches[0].clientX;
                touchStartY = touches[0].clientY;
                startPosX = currentX;
                startPosY = currentY;
            }
        });

        function zoomIn() {
            const centerX = containerWidth / 2;
            const centerY = containerHeight / 2;
            const newScale = Math.min(currentScale * (1 + ZOOM_SPEED * 2), MAX_ZOOM);
            if (newScale === currentScale) return;

            const imageMouseX = (centerX - currentX) / currentScale;
            const imageMouseY = (centerY - currentY) / currentScale;
            currentScale = newScale;
            currentX = centerX - (imageMouseX * currentScale);
            currentY = centerY - (imageMouseY * currentScale);
            applyTransform();
        }

        function zoomOut() {
            const centerX = containerWidth / 2;
            const centerY = containerHeight / 2;
            const newScale = Math.max(currentScale * (1 - ZOOM_SPEED * 2), MIN_ZOOM);
            if (newScale === currentScale) return;

            const imageMouseX = (centerX - currentX) / currentScale;
            const imageMouseY = (centerY - currentY) / currentScale;
            currentScale = newScale;
            currentX = centerX - (imageMouseX * currentScale);
            currentY = centerY - (imageMouseY * currentScale);
            applyTransform();
        }

        function fitToScreen() {
            const fit = calculateFitToScreen();
            currentScale = fit.scale;
            currentX = fit.x;
            currentY = fit.y;
            applyTransform();
        }

        function resetZoom() {
            currentScale = 1.0;
            currentX = 0;
            currentY = 0;
            applyTransform();
        }

        $('#control-plus').on('click', zoomIn);
        $('#control-minus').on('click', zoomOut);
        $('#control-fit').on('click', fitToScreen);
        $('#control-reset').on('click', resetZoom);

        const PAN_STEP = 50;
        $('#control-left').on('click', function () {
            currentX += PAN_STEP;
            applyTransform();
        });
        $('#control-right').on('click', function () {
            currentX -= PAN_STEP;
            applyTransform();
        });
        $('#control-up').on('click', function () {
            currentY += PAN_STEP;
            applyTransform();
        });
        $('#control-down').on('click', function () {
            currentY -= PAN_STEP;
            applyTransform();
        });

        window.imageZoom = {
            zoomIn: zoomIn,
            zoomOut: zoomOut,
            fitToScreen: fitToScreen,
            resetZoom: resetZoom
        };

        img.on('load', function () {
            initializeImage();
            updateZoomDisplay();
        });

        if (img[0].complete) {
            initializeImage();
            updateZoomDisplay();
        }

        $(window).on('resize', function () {
            const oldContainerWidth = containerWidth;
            const oldContainerHeight = containerHeight;
            containerWidth = pictureArea.width();
            containerHeight = pictureArea.height();

            if (oldContainerWidth && oldContainerHeight) {
                currentX = currentX * (containerWidth / oldContainerWidth);
                currentY = currentY * (containerHeight / oldContainerHeight);
                applyTransform();
            }
        });

        $(document).on('keydown', function (e) {
            if (e.target.tagName.toLowerCase() === 'input' ||
                e.target.tagName.toLowerCase() === 'textarea' ||
                e.target.contentEditable === 'true') {
                return;
            }
            switch (e.key) {
                case '+':
                case '=':
                    e.preventDefault();
                    zoomIn();
                    break;
                case '-':
                case '_':
                    e.preventDefault();
                    zoomOut();
                    break;
                case '0':
                    e.preventDefault();
                    if (e.ctrlKey || e.metaKey) {
                        resetZoom();
                    } else {
                        fitToScreen();
                    }
                    break;
                case 'а':
                case 'А':
                    e.preventDefault();
                    fitToScreen();
                    break;
                case 'к':
                case 'К':
                    e.preventDefault();
                    resetZoom();
                    break;

                case 'ArrowLeft':
                    e.preventDefault();
                    currentX += PAN_STEP;
                    applyTransform();
                    break;
                case 'ArrowRight':
                    e.preventDefault();
                    currentX -= PAN_STEP;
                    applyTransform();
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    currentY += PAN_STEP;
                    applyTransform();
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    currentY -= PAN_STEP;
                    applyTransform();
                    break;
            }

            if (e.ctrlKey || e.metaKey) {
                switch (e.key) {
                    case '+':
                    case '=':
                        e.preventDefault();
                        zoomIn();
                        break;
                    case '-':
                    case '_':
                        e.preventDefault();
                        zoomOut();
                        break;
                }
            }
        });
    }
}

